import React from "react";
import Chart from "react-apexcharts";
import { Card, CardHeader, CardBody } from "reactstrap";

const RoomTypeRevenueChart = ({ roomTypes = {} }) => {

  const categories = Object.keys(roomTypes);

  const values = Object.values(roomTypes);

  const series = [
    {
      name: "Revenue",
      data: values,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
        distributed: true,
        borderRadius: 6,
      },
    },

    colors: [
      "#3cd188",
      "#efae4e",
      "#4b7bec",
      "#f7666e",
      "#9b59b6",
      "#00cfe8",
      "#ff9f43",
      "#7367f0",
    ],

    stroke: {
      show: true,
      width: 5,
      colors: ["transparent"],
    },

    xaxis: {
      categories,

      axisTicks: {
        show: false,
      },

      title: {
        text: "Room Type",
        style: {
          color: "#78909C",
          fontSize: "12px",
          fontWeight: 400,
        },
      },
    },

    yaxis: {
      min: 0,

      labels: {
        formatter: (value) =>
          `₹${Number(value).toLocaleString()}`,
      },

      title: {
        text: "Revenue",
      },
    },

    legend: {
      show: false,
    },

    fill: {
      opacity: 1,
    },

    tooltip: {
      y: {
        formatter: (value) =>
          `₹${Number(value).toLocaleString()}`,
      },
    },
  };

  return (
    <Card className="card-height-100">
      <CardHeader className="align-items-center d-flex">
        <h4 className="card-title mb-0 flex-grow-1">
          Revenue By Room Type
        </h4>
      </CardHeader>

      <CardBody>
        <Chart
          options={options}
          series={series}
          type="bar"
          height={350}
        />
      </CardBody>
    </Card>
  );
};

export default RoomTypeRevenueChart;